import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { LogClient, LogCommand } from "../../INTEGRA_Shop_Client";
import { ILoggerApiService, ILoggerApiServiceToken } from "./logger-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class LoggerApiService implements ILoggerApiService {

  constructor(
    private loggerClient: LogClient,
  ) { }

  public logToBackend(command: LogCommand): Observable<void> {
    return this.loggerClient.log(command);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const LoggerApiServiceProvider: Provider[] = [
  { provide: LogClient },
  { provide: ILoggerApiServiceToken, useExisting: LoggerApiService }
]
